import type { DashboardWidgetConfiguration } from './widget-definition';

export const financeBankAccountPositionWidget: DashboardWidgetConfiguration = {
  widgetId: "finance.bank-account-position",
  name: "Bank account position",
  description: "Posted Finance journal balances at a selected date, scoped by RQL permissions.",
  apps: [
    "finance",
  ],
  template: "finance-money",
  query: {
    kind: "component",
    owner: "finance-money",
  },
  inputs: {
    title: "Bank account position",
    mode: "bank",
  },
  dummyData: {
    value: "Posted balances",
    rows: [],
  },
  limits: {
    minWidth: 6,
    maxWidth: 12,
    minHeight: 4,
    maxHeight: 12,
    defaultWidth: 12,
    defaultHeight: 6,
  },
};
